import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a26cb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-menu" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = {
  key: 0,
  role: "tree",
  id: "tags-list"
}

import TagsListMobile from '@/components/Tags/TagsListMobile.vue';
import { useHome } from '@/store/useHome';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsLinkList',
  setup(__props) {

const { home } = useHome();

const isExpanded = ref(false);

const toggleExpansion = () => {
  isExpanded.value = !isExpanded.value;
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(home)?.filterMenu)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("button", {
            onClick: toggleExpansion,
            "aria-expanded": isExpanded.value,
            "aria-controls": "tags-list"
          }, [
            _createElementVNode("h2", null, [
              _createTextVNode(_toDisplayString(_unref(home).filterMenu.title) + " ", 1),
              _createVNode(_component_Icon, {
                "aria-hidden": "true",
                name: isExpanded.value ? 'up' : 'down',
                class: "chevron"
              }, null, 8, ["name"])
            ])
          ], 8, _hoisted_2),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (isExpanded.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(home).filterMenu.mainTags, (mainTag) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: mainTag.id,
                        role: "treeitem"
                      }, [
                        _createVNode(TagsListMobile, {
                          tag: mainTag,
                          onOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["tag"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})